import { InformacionFamiliarData } from 'components/InformacionFamiliar'
import IconCloseModal from 'components/Varios/Modals/IconCloseModal'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter, Row, Col, Label, FormGroup, InputGroup, Input, InputGroupAddon } from "reactstrap"
import Datepicker from "components/Varios/Datepicker.js";
import { InformacionTablaSustitutoFamiliar, NuevaInformacionSustitutoFamiliar } from './TypesSustitutoFamiliar';
import ButtonAceptar from 'components/Varios/Modals/ButtonAceptar';
import InputFileUpload from 'components/Varios/InputFileUpload';
import InputFileDownload from 'components/Varios/InputFileDownload';
import { FilesUpload } from 'components/Types/GeneralTypes';

import configData from "config.json"
import { ActualizarInformacionSustitutoFamiliar, AgregarInformacionSustitutoFamiliar } from './FunctionsSustitutoFamiliar';
import Cargando from 'components/Varios/Cargando';
import { alertService } from 'components/Varios/alert_service';
import { SumarDiasFecha } from 'functions/DatesFunctions';

type PropModalAgregarInformacion = {
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    onClose: () => void,
    informacionFamiliar: InformacionFamiliarData
    editarInformacionSustituto?: InformacionTablaSustitutoFamiliar
    onAccion: () => Promise<void>

}


export default function ModalAgregarInformacionSustituto(props: PropModalAgregarInformacion) {

    const nuevaSustitucionDefault: NuevaInformacionSustitutoFamiliar = {
        fechaCaducidadCertificado: undefined,
        idPersonaDependiente: 0,
        numeroCertificado: undefined,
        fechaEmisionCertificado: undefined
    };




    const [stateSustituto, setstateSustituto] = useState<NuevaInformacionSustitutoFamiliar>(nuevaSustitucionDefault)
    const [certificado, setcertificado] = useState<FilesUpload | null>(null)
    const [mensajeAccion, setmensajeAccion] = useState<string | undefined>(undefined)
    const [mensajeExitoAccion, setmensajeExitoAccion] = useState<string | undefined>(undefined)
    const [loadingAccion, setloadingAccion] = useState<boolean>(false)
    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal
                handleClickIcon={() => props.onClose()}
            />
        )
    }, [props])

    useEffect(() => {
        const { editarInformacionSustituto } = props;
        if (editarInformacionSustituto && editarInformacionSustituto.tabla !== "TBL_DEPENDIENTE_PERSONA") {
            setstateSustituto({
                idPersonaDependiente: editarInformacionSustituto.idPersonaDependiente,
                numeroCertificado: editarInformacionSustituto.nrocertificacion,
                fechaCaducidadCertificado: editarInformacionSustituto.fechaCaducidad,
                fechaEmisionCertificado: editarInformacionSustituto.fechaEmision,
                idDatosSustitucionFamiliar: editarInformacionSustituto.idDatosSustitucionFamiliar,
                refArchivoCertificado: editarInformacionSustituto.refevidencia
            })
        }
    }, [props])




    const onChangeData = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {

            var valor = { ...stateSustituto }
            valor[event.target.name] = event.target.value

            setstateSustituto({ ...valor })
        },
        [stateSustituto, props],
    )

    const onSelect = useCallback(
        (value: string, name: string) => {
            var valor = { ...stateSustituto }
            valor[name] = value
            setstateSustituto({ ...valor })
        }
        , [stateSustituto, props])

    const handleFileUploadChange = useCallback(
        (nombreArchivo: string, uploadFile: File) => {
            const src = window.URL.createObjectURL(uploadFile);
            const fileInfo: FilesUpload = { nameFile: nombreArchivo, uploadFile, src };

            setcertificado(fileInfo)
        }
        , [stateSustituto, props])


    const enviarDatos = useCallback(async () => {
        if (stateSustituto !== undefined && certificado !== null) {
            setloadingAccion(true)
            const resultado = await AgregarInformacionSustitutoFamiliar(stateSustituto, certificado, props.informacionFamiliar.iddependientepersona);

            if (resultado.status !== 200) {
                setmensajeAccion(resultado.errorMessage);
            }
            else if (resultado.status === 200) {
                setmensajeExitoAccion("Se ha agregado con éxito la información")
            }
            setloadingAccion(false)

        }

    }, [props, stateSustituto, certificado])

    const actualizarDatos = useCallback(async () => {
        if (stateSustituto !== undefined) {
            setloadingAccion(true)

            const resultado = await ActualizarInformacionSustitutoFamiliar(stateSustituto, props.informacionFamiliar.iddependientepersona, certificado);

            if (resultado.status !== 200) {
                setmensajeAccion(resultado.errorMessage);
            }
            else if (resultado.status === 200) {
                setmensajeExitoAccion("Se ha actualizado con éxito la información")
            }
            setloadingAccion(false)

        }

    }, [props, stateSustituto, certificado])


    const ContenidoModalBody = useMemo(() => {

        return (
            <React.Fragment>


                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <Label for="discapcarnet"># de la certificación*</Label>
                            <InputGroup>
                                <Input type="text" maxLength="50" value={stateSustituto.numeroCertificado} name="numeroCertificado" onChange={(e) => onChangeData(e)} required />
                                <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                    <i className="fas fa-hashtag" aria-hidden="true"></i>
                                </InputGroupAddon>
                            </InputGroup>

                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="fechaemisioncertsustituto">F. emisión certificación*</Label>
                            <Datepicker
                                value={stateSustituto.fechaEmisionCertificado}
                                name="fechaEmisionCertificado"
                                id="fechaemisioncertsustituto"
                                onChange={(name, value) => onSelect(name, value)}
                                max = { new Date()}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Label for="fechacaducidadcertsustituto">F. caducidad certificación*</Label>
                            <Datepicker
                                value={stateSustituto.fechaCaducidadCertificado}
                                name="fechaCaducidadCertificado"
                                id="fechacaducidadcertsustituto"
                                onChange={(name, value) => onSelect(name, value)}
                                min = {stateSustituto.fechaEmisionCertificado}
                            />

                        </FormGroup>
                    </Col>


                    <Col md={4}>
                        <FormGroup>
                            <Label for="certificado" md={2} className="pt-0">Certificado*</Label>

                            <div className="containerEvidenciaDG">
                                <InputFileUpload
                                    className="firstevidencia"
                                    icon="upload"
                                    onChange={(nombreArchivo, uploadFile) => handleFileUploadChange(nombreArchivo, uploadFile)}
                                    name="CERT"
                                    placeholder={stateSustituto.refArchivoCertificado === undefined ? "Subir Certificado " : "Actualizar Certificado"}
                                    required={true}
                                />
                                <InputFileDownload tipo="certificado"
                                    id="downloadRef"
                                    refarchivo={stateSustituto.refArchivoCertificado}
                                    name={"CERTIFICADO.pdf"}
                                    // url={configData.SERVER_URL + "Files/GetArchivoVistaPrevia/refArchivo/" + props.informacionFamiliar.refarchivodoc4}
                                    url={configData.SERVER_URL + "Files/GetArchivoVistaPrevia/refArchivo/" + stateSustituto.refArchivoCertificado}

                                    className="secondevidenciabottom iconwhite"
                                />
                            </div>

                        </FormGroup>
                    </Col>

                </Row>
                {
                    loadingAccion && !mensajeAccion && !mensajeExitoAccion && <Cargando />
                }
                {
                    mensajeAccion &&
                    <Row className="justify-content-center">
                        <Col>
                            <p className='small-error text-center'>{mensajeAccion}</p>
                        </Col>
                    </Row>
                }
                {
                    mensajeExitoAccion &&
                    <Row className="justify-content-center">
                        <Col>
                            <p className='bold text-center'>{mensajeExitoAccion}</p>
                        </Col>
                    </Row>
                }

            </React.Fragment>
        )

    }, [props, stateSustituto, mensajeAccion, mensajeExitoAccion, loadingAccion])

    const BotonAccion = useMemo(() => {
        if (props.editarInformacionSustituto !== undefined && props.editarInformacionSustituto.tabla !== "TBL_DEPENDIENTE_PERSONA") {
            return (
                <button type='button' className='btn' disabled={stateSustituto === undefined || (certificado === null && stateSustituto.refArchivoCertificado === undefined)} onClick={async () => await actualizarDatos()}>Actualizar</button>
            )
        }
        else {
            return (
                <button type='button' className='btn' disabled={stateSustituto === undefined || certificado === null} onClick={async () => await enviarDatos()}>Enviar</button>
            )
        }

    }, [enviarDatos, stateSustituto, certificado, props])


    useEffect(
        () => {
            if (mensajeExitoAccion !== undefined) {
                alertService.success("La información ha sido agregada/actualizada con éxito")
                props.onAccion()
            }
        }, [mensajeExitoAccion])



    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={true}
            onClosed={() => props.onClose()}
            toggle={() => props.onClose()}
            contentClassName={"custom-modal-NuevoSustitutoFamiliar"}
        >
            <ModalHeader close={BotonCerrar} toggle={() => props.onClose()}>
                <div className='tituloModalDocumentos'>{"Ingreso de datos de Sutitución de " + props.informacionFamiliar.nombres + " " + props.informacionFamiliar.apellidos }</div>
            </ModalHeader>
            <ModalBody>
                {ContenidoModalBody}
            </ModalBody>
            <ModalFooter>
                {BotonAccion}
                <ButtonAceptar
                    handleClickAceptar={() => props.onClose()}
                    nombreBoton={"Cerrar"}
                />
            </ModalFooter>
        </Modal>
    )
}
